import * as React from 'react'

interface SelectCheckboxContextValue {
  defaultValues: ValuesProps
}

type SelectCheckboxContextProviderProps = {
  value: SelectCheckboxContextValue
}

type HandleOnChangeProps = {
  value: string
  isChecked: boolean
  onChangeCallback?: (v: ValuesProps) => void
}

export type ValuesProps = string[]

const SelectCheckboxContext = React.createContext<{
  values: ValuesProps
  isChecked?: (v: string) => boolean
  onChange?: (props: HandleOnChangeProps) => void
  setValues?: React.Dispatch<React.SetStateAction<ValuesProps>>
}>({ values: [] })

const SelectCheckboxProvider = ({
  value: { defaultValues },
  children,
}: React.PropsWithChildren<SelectCheckboxContextProviderProps>) => {
  const [values, setValues] = React.useState<ValuesProps>([])

  const handleValueChange = ({ value, isChecked, onChangeCallback }: HandleOnChangeProps) => {
    let newValues: ValuesProps = values
    if (isChecked) {
      const updatedValues = values.filter((v) => String(v || '') !== String(value))
      newValues = updatedValues
    } else {
      const updatedValues = [...values, String(value || '')]
      newValues = updatedValues
    }
    setValues(newValues)
    onChangeCallback && onChangeCallback(newValues)
  }

  const verifyIsValueChecked = (v: string) => values.includes(String(v || ''))

  React.useEffect(() => {
    if (defaultValues.length > 0) setValues(defaultValues)
  }, [defaultValues])

  return (
    <SelectCheckboxContext.Provider
      value={{
        values,
        isChecked: verifyIsValueChecked,
        onChange: handleValueChange,
        setValues,
      }}
    >
      {children}
    </SelectCheckboxContext.Provider>
  )
}

export { SelectCheckboxContext, SelectCheckboxProvider }
